import React, { useState, useCallback, useEffect, useReducer } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import {
  SelectComponet,
  TabsComponent,
  Spinner,
} from "../../../../../../Components";
import {
  GetParams,
  GlobalHistory,
  showError,
  showSuccess,
} from "../../../../../../Helper";
import {
  GetAllClubContactsAPI,
  GetAllClubLeadsAPI,
} from "../../../../../../Services";

import {
  PSIClubCommissionsComponent,
  ContactProfilePSIClubReferrals,
} from "./ContactProfilePSIClubUtilities";

export const ContactProfilePSIClubComponent = ({
  parentTranslationPath,
  translationPath,
  contactWithPolicy,
}) => {
  const { t } = useTranslation(parentTranslationPath);
  const location = useLocation();
  const [activeItem, setActiveItem] = useState(null);
  const [contactId, setContactId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [actionType, setActionType] = useState({ id: null, value: null });
  const [status, setStatus] = useState([]);
  const reducer = useCallback((state, action) => {
    if (action.id !== "edit") return { ...state, [action.id]: action.value };
    return {
      ...action.value,
    };
  }, []);
  const [state, setState] = useReducer(reducer, {
    leadIds: [],
    leads: [],
    userType: null,
  });

  const defaultFilter = {
    pageSize: parseInt(localStorage.getItem("Pagination")) || 25,
    pageIndex: 0,
    contactId: null,
    leadStatus: null,
  };
  const defaultCommissionsFilter = {
    pageSize: parseInt(localStorage.getItem("Pagination")) || 25,
    pageIndex: 0,
    contactId: null,
    leadStatus: null,
  };

  const [filter, setFilter] = useState({
    ...defaultFilter,
  });

  const [leadsDetailes, setLeadsDetailes] = useState(null);
  const { pathname } = useLocation();
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    setContactId(+GetParams("id"));
  }, [GetParams("id")]);

  const GetAllPSIClubReferrals = useCallback(async () => {
    setIsLoading(true);
    let res = await GetAllClubLeadsAPI({
      ...filter,
      pageIndex: filter.pageIndex + 1,
      contactId: contactId,
      leadStatus: filter?.leadStatus,
    });
    if (!(res && res.status && res.status !== 200)) {
      setLeadsDetailes({
        result: res?.result || [],
        totalCount: res && res.totalCount,
      });
    } else {
      setLeadsDetailes({
        result: [],
        totalCount: 0,
      });
    }
    setIsLoading(false);
  }, [filter, activeTab, contactId]);

  const onTabChanged = (e, newTap) => {
    setActiveTab(newTap);
  };
  useEffect(() => {
    if (activeTab === 0 && contactId) GetAllPSIClubReferrals();
  }, [activeTab, GetAllPSIClubReferrals]);

  return (
    <div className="associated-contacts-wrapper childs-wrapper">
      <Spinner isActive={isLoading} isAbsolute />
      <div className="filter-sections-wrapper mb-2">
        <div className="filter-section-item">
          <span className="mt-2 mb-2 px-4 fz-14px d-flex">
            <span className="mdi mdi-information-outline c-danger px-2 mt-2" />
            {activeTab === 0 ? (
              <h5 style={{ "line-height": "22px" }}>
                {t`${translationPath}leads-referred-via-the-PSI-Club-Portal`}
              </h5>
            ) : (
              <h5 style={{ "line-height": "22px" }}>
                {" "}
                {t`${translationPath}lists-commissions-for-leads-submitted-via-the-PSI-Club-Portal`}{" "}
              </h5>
            )}
          </span>
        </div>
      </div>
      <div className="contact-units-wrapper  px-4">
        <TabsComponent
          data={[
            {
              label: "member-referral-leads",
              component: ContactProfilePSIClubReferrals,
            },
            {
              label: "members-commission-tracking",
              component: PSIClubCommissionsComponent,
            },
          ]}
          labelInput="label"
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
          wrapperClasses="is-with-line"
          currentTab={activeTab}
          onTabChanged={onTabChanged}
          dynamicComponentProps={{
            parentTranslationPath,
            translationPath,
            activeTab,
            leadsDetailes,
            filter,
            setFilter,
          }}
        />
      </div>
    </div>
  );
};
